var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.284,
    height: 28.284,
    viewBox: "0 0 28.284 28.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#1c1b18;stroke-width:2px;}.c,.d{stroke:none;}.d{fill:#1c1b18;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14521.852 -5483.613) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-6376 14133)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M5-2a5,5,0,0,1,5,5V21.75L5,28,0,21.75V3A5,5,0,0,1,5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M 5 0 C 3.345789909362793 0 2 1.345790863037109 2 3 L 2 21.04843521118164 L 5 24.79843521118164 L 8 21.04843521118164 L 8 3 C 8 1.345790863037109 6.654210090637207 0 5 0 M 5 -2 C 7.761420249938965 -2 10 0.2385807037353516 10 3 L 10 21.75 L 5 28 L 0 21.75 L 0 3 C 0 0.2385807037353516 2.238580226898193 -2 5 -2 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-6375.229,14149.563h7",
    transform: "translate(0.665 4.043)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-6375.229,14149.563h7",
    transform: "translate(0.23 -12.149)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.38cd042f.svg";
export { ForwardRef as ReactComponent };